export default __webpack_public_path__ + "components/icon/static/list-e5ae756a9f3d79e979c208688bc63852.svg";